import { render, staticRenderFns } from "./expand-menu.vue?vue&type=template&id=6f846ce2&scoped=true&"
import script from "./expand-menu.vue?vue&type=script&lang=js&"
export * from "./expand-menu.vue?vue&type=script&lang=js&"
import style0 from "./expand-menu.vue?vue&type=style&index=0&id=6f846ce2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f846ce2",
  null
  
)

export default component.exports